import { render, staticRenderFns } from "./ProgramDetail.vue?vue&type=template&id=d642e57e&scoped=true&"
import script from "./ProgramDetail.vue?vue&type=script&lang=js&"
export * from "./ProgramDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetail.vue?vue&type=style&index=0&id=d642e57e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d642e57e",
  null
  
)

export default component.exports